import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ip_list",
  "use": "ip_list-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ip_list\"><g fill-rule=\"evenodd\"><path d=\"M15 14a1 1 0 01-1 1H2a1 1 0 01-1-1V3h14v11zM14 0H2C.897 0 0 .897 0 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2z\" /><path d=\"M4 13h1.143V5H4zM8.066 6.066H10.2a1.068 1.068 0 010 2.134H8.066V6.066zm0 3.2H10.2a2.135 2.135 0 002.133-2.133A2.135 2.135 0 0010.2 5H7v8h1.066V9.266z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id